import { PublishOrEditRunbookSnapshot } from "./PublishOrEditRunbookSnapshot";
export function PublishNewSnapshotPage() {
    return <PublishOrEditRunbookSnapshot />;
}
